import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, model } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { t } from 'app/core/i18n/i18n';

/**
 * Toolbar search input building block.
 * Provides two-way binding with model() for search value.
 *
 * @example
 * ```html
 * <app-toolbar-search
 *   [(value)]="searchTerm"
 *   placeholder="Nombre, código..."
 * />
 * ```
 */
@Component({
  selector: 'app-toolbar-search',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    MatButtonModule,
  ],
  template: `
    <mat-form-field class="w-full sm:w-64 md:w-80" subscriptSizing="dynamic">
      <input
        matInput
        type="text"
        [placeholder]="placeholder"
        [ngModel]="value()"
        (ngModelChange)="onValueChange($event)"
      />
      <mat-icon matPrefix class="mr-2">search</mat-icon>
      @if (value()) {
        <button matSuffix mat-icon-button (click)="clear()">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarSearchComponent {
  @Input() placeholder = t('routing.SUB_ROUTE_PARTNERS.TOOLBAR.SEARCH_DEFAULT_PLACEHOLDER');

  /** Two-way binding for search value using Angular 17.2+ model() */
  value = model<string>('');

  onValueChange(newValue: string): void {
    this.value.set(newValue);
  }

  clear(): void {
    this.value.set('');
  }
}
